/*
|-------------------------------------------------------------------------------
| Vuex modules/cancellation.js
|-------------------------------------------------------------------------------
| Vuex data store for user
*/

import UserAPI from '@/api/user';
import router from '@/router';

export const user = {
    namespaced: true,
    state: {
        // user: {},
        isLoading: false,
        errorText: '',
    },
    actions: {
        async login({ commit }, { email, password }) {
            commit('setIsLoading', true);

            try {
                const { data } = await UserAPI.login(email, password);

                // Remove this once Vuex Persist is properly set up
                localStorage.setItem('api_token', data.access_token);
                localStorage.setItem('roles', data.roles);
                localStorage.setItem('name', data.name);

                localStorage.setItem('user', JSON.stringify(data));
                ///////////////////////////////////////////

                // commit('setUser', data);
                router.push({ path: '/search' });
            } catch (error) {
                // commit('setUser', {});
                if (401 === error.response.status) {
                    commit(
                        'setErrorText',
                        'You have entered an invalid email or password'
                    );
                }
                console.error(error.response);
            } finally {
                commit('setIsLoading', false);
                setTimeout(() => {
                    commit('setErrorText', '');
                }, 3000);
            }
        },
        logout() {
            localStorage.clear();
            router.push({ path: '/login' });
        },
    },
    mutations: {
        // setUser(state, payload) {
        //     state.user = payload;
        // },
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        setErrorText(state, payload) {
            state.errorText = payload;
        },
    },
    getters: {
        // getUser: (state) => state.user,
        getIsLoading: (state) => state.isLoading,
        getErrorText: (state) => state.errorText,
    },
};
